export const PLP_LABELS = 'PLP.plpTiles';
export const PLP_SORT_LABELS = 'PLP.PLP_sort_filter';
export const addToBagText = 'lbl_add_to_bag';
export const inGridDescriptionText = 'lbl_plp_in_grid_description';
export const inMultiGridHeaderText = 'lbl_plp_in_multi_grid_header';
export const inMultiGridDescriptionText = 'lbl_plp_in_multi_grid_description';
export const referred = 'referred';
export const lblPdpSizeError = 'lbl_pdp_size_error';
export const lblPdpSize = 'lbl_pdp_size';
export const lblPdpFit = 'lbl_pdp_fit';
export const lblPdpColor = 'lbl_pdp_color';
export const lblPdpQuantity = 'lbl_pdp_quantity';
export const lblPlpTilesShopCollection = 'lbl_plpTiles_shop_collection';
export const lblSizeUnavailableOnline = 'lbl_size_unavailable_online';
export const lblOtherSizesAvailable = 'lbl_other_sizes_available';
export const lblSeeSuggestedItems = 'lbl_see_suggested_items';
export const lblFavSaveProduct = 'lbl_fav_save_product';
export const lblDismiss = 'lbl_dismiss';
export const lblSuggested = 'lbl_suggested';
export const lblAddToFavorites = 'lbl_add_to_favorites';
export const lblSizeChart = 'lbl_size_chart';
export const lblYouMayAlsoLike = 'lbl_you_may_also_like';
export const lblRecentlyViewed = 'lbl_recently_viewed';
export const lblPageNotFound = 'lbl_page_not_found';
export const lblViewDetails = 'lbl_view_details';
export const lblPlpTilesShopTheLook = 'lbl_plpTiles_shop_the_look';
export const lblSoldOut = 'lbl_sold_out';
export const lblSeeSimilarItems = 'lbl_see_similar_items';
export const lblPlpRecosProducttilesTitle = 'lbl_plp_recos_producttiles_title';
export const lblPlpInGridDescription = 'lbl_plp_in_grid_description';
export const lblPlpPersonalized = 'lbl_plp_personalized';
export const lblPlpInMultiGridHeader = 'lbl_plp_in_multi_grid_header';
export const lblPlpInMultiGridDescription = 'lbl_plp_in_multi_grid_description';
export const lblAddToBagRedesign = 'lbl_add_to_bag_redesign';
export const lblRcommAtbBtnRedesign = 'lbl_rcomm_atb_btn_redesign';
export const lblPlpAlsoAvailableIn = 'lbl_plp_also_available_in';
export const lblPlpSelectStore = 'lbl_plp_select_store';
export const lblPlpSelectAt = 'lbl_plp_select_at';
export const lblPlpChangeStore = 'lbl_plp_change_store';
export const lblPlpSelectNearbyStore = 'lbl_plp_select_nearby_store';
export const lblPlpPickupInStore = 'lbl_plp_pickup_in_store';
export const lblYouMayLike = 'lbl_you_may_like';
export const lblAccessorySelectAddOn = 'lbl_accessory_select_add_on';
export const lblAccessorySelected = 'lbl_accessory_selected';
export const lblAddAccessory = 'lbl_add_accessory';
export const lblViewAll = 'lbl_view_all';
export const lblShopAll = 'lbl_shop_all';
export const lblItems = 'lbl_items';
export const lblPdpUpdate = 'lbl_pdp_update';
export const lblRemoveAccessory = 'lbl_remove_accessory';
export const lblRemove = 'lbl_remove';
export const lblAccessoryUpdateAddOn = 'lbl_accessory_update_add_on';
export const lblUpdateAccessory = 'lbl_update_accessory';
export const repStr = 'BASED ON YOUR RECENT PURCHASE';
export const recentlyViewd = 'RECENTLY VIEWED';
export const readLessText = 'lbl_read_less';
export const readMoreText = 'lbl_read_more';

// PLP Sort Labels -
export const lblApply = 'lbl_apply';
export const lblAvailability = 'lbl_availability';
export const lblClear = 'lbl_clear';
export const lblClearTxt = 'lbl_clearTxt';
export const lblColor = 'lbl_color';
export const lblFilter = 'lbl_filter';
export const lblFilterBy = 'lbl_filter_by';
export const lblFilterSort = 'lbl_filter_sort';
export const lblFilteringBy = 'lbl_filtering_by';
export const lblGender = 'lbl_gender';
export const lblPrice = 'lbl_price';
export const lblReset = 'lbl_reset';
export const lblSeeResults = 'lbl_see_results';
export const lblShowResults = 'lbl_show_results';
export const lblShowResultsTxt = 'lbl_show_results_txt';
export const lblSize = 'lbl_size';
export const lblSort = 'lbl_sort';
export const lblSortAb = 'lbl_sort_ab';
export const lblSortBy = 'lbl_sort_by';
export const lblShowFilters = 'lbl_show_filters';
export const lblHideFilters = 'lbl_hide_filters';

// shop by look stylitics
export const styliticsShopButton = 'lbl_stylitics_shop_button_text';
export const styliticsOosOverlay = 'lbl_stylitics_oos_overlay_text';
export const styliticsBackToLook = 'lbl_stylitics_back_to_look_text';
export const styliticsModalHeader = 'lbl_stylitics_modal_header_text';

export const PLPLabels = {
  PLP: {
    plpTiles: {
      [addToBagText]: 'ADD TO BAG',
      [inMultiGridHeaderText]: 'FOR YOU',
      [inGridDescriptionText]: repStr,
      [inMultiGridDescriptionText]: repStr,

      [referred]: '',
      [lblPdpSizeError]: 'Please select a size.',
      [lblPdpSize]: 'SIZE',
      [lblPdpFit]: 'Fit',
      [lblPdpColor]: 'COLOR',
      [lblPdpQuantity]: 'QUANTITY',
      [lblPlpTilesShopCollection]: 'Shop Collection',
      [lblSizeUnavailableOnline]: 'Size unavailable online?',
      [lblOtherSizesAvailable]: 'Other Sizes Available',
      [lblSeeSuggestedItems]: 'See suggested items',
      [lblFavSaveProduct]: 'Save Product',
      [lblDismiss]: 'Dismiss',
      [lblSuggested]: 'SUGGESTED',
      [lblAddToFavorites]: 'Add to Favorites',
      [lblSizeChart]: 'Size Chart',
      [lblYouMayAlsoLike]: 'YOU MAY ALSO LIKE',
      [lblRecentlyViewed]: recentlyViewd,
      [lblPageNotFound]: 'Page Not Found',
      [lblViewDetails]: 'View Product Details',
      [lblPlpTilesShopTheLook]: 'SHOP THE LOOK',
      [lblSoldOut]: 'Sold Out',
      [lblSeeSimilarItems]: 'See Similar Items',
      [lblPlpRecosProducttilesTitle]: 'SHOP THEM NOW',
      [lblPlpInGridDescription]: repStr,
      [lblPlpInMultiGridHeader]: 'FOR YOU',
      [lblPlpInMultiGridDescription]: repStr,
      [lblAddToBagRedesign]: 'Add to Bag',
      [lblRcommAtbBtnRedesign]: 'ADD TO BAG',
      [lblPlpAlsoAvailableIn]: 'ALSO AVAILABLE IN',
      [lblPlpSelectStore]: 'Select store',
      [lblPlpSelectAt]: 'Pick up at',
      [lblPlpChangeStore]: 'Change Store',
      [lblPlpSelectNearbyStore]: 'Select store to see what is available near you',
      [lblPlpPickupInStore]: 'PICK UP IN STORE',
      [lblYouMayLike]: 'YOU MAY LIKE',
      [lblAccessorySelectAddOn]: 'Select',
      [lblAccessorySelected]: 'Accessory Selected',
      [lblAddAccessory]: 'ADD ACCESSORY',
      [lblViewAll]: 'VIEW ALL',
      [lblShopAll]: 'Shop all',
      [lblItems]: 'items',
      [lblPdpUpdate]: 'Update',
      [lblRemoveAccessory]: 'REMOVE',
      [lblRemove]: 'REMOVE',
      [lblAccessoryUpdateAddOn]: 'UPDATE',
      [lblUpdateAccessory]: 'UPDATE',
      [styliticsShopButton]: 'Shop',
      [styliticsOosOverlay]: 'Out of Stock',
      [styliticsBackToLook]: 'Back to Look',
      [styliticsModalHeader]: 'Product List',
    },
    seoText: { [readMoreText]: 'Read More +', [readLessText]: 'Read Less -' },
    PLP_sort_filter: {
      [lblApply]: 'Apply',
      [lblAvailability]: 'Availability',
      [lblClear]: 'Clear All',
      [lblClearTxt]: 'Clear',
      [lblColor]: 'Color',
      [lblFilter]: 'FILTER',
      [lblFilterBy]: 'Filter By:',
      [lblFilterSort]: 'Filter & Sort',
      [lblFilteringBy]: 'Filtering By',
      [lblGender]: 'Gender',
      [lblPrice]: 'Price',
      [lblReset]: 'Reset',
      [lblSeeResults]: 'See Results',
      [lblShowResults]: 'show results',
      [lblShowResultsTxt]: 'Show Results',
      [lblSize]: 'Size',
      [lblSort]: 'SORT',
      [lblSortAb]: 'Sort',
      [lblSortBy]: 'Sort By: ',
      [lblShowFilters]: 'Show Filters',
      [lblHideFilters]: 'Hide Filters',
    },
  },
};
